import React from 'react'
import Topheader from '../../Home/topHeader/Topheader'
import Middlebar from '../../Home/middleBar/Middlebar'
import NavMenu from '../../Home/navigationBar/NavMenu'
import Mission from '../aboutus/Mission'
import Vision from '../aboutus/Vision'
import Objective from '../aboutus/Objective'
import Footer from '../../Home/footer/Footer'

function MissionVission() {
  return (
    <>
      <Topheader/>
      <Middlebar/>
      <NavMenu/>
      <div className="container py-10" >
        {/* <h1 className='text-center text-5xl my-5 py-4 text-maroon font-poppins font-bold'>Mission & Vision</h1> */}

        <Mission/>
        <Vision/>
        <Objective/>
        </div>
        <Footer/>
    </>
  )
}

export default MissionVission
